<template>
<div class="container element-margin">
  <h2 class="text-center text-muted flow-title align-self-center ">
    Repair Estimate
  </h2>
  <b-container class="bv-example-row box shadow-sm">
    <b-row class="justify-content-md-center">
      <b-col cols="12" md="auto">
        <h3>Enter the repair estimate:</h3>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center mt-3">
      <b-col cols="12" md="auto">
        <input v-model="repairOfferAmount" type="number" class="form-control my-auto" placeholder="Enter amount">
      </b-col>
    </b-row>
    <b-col align-self="center">
      <b-button :disabled="!repairOfferAmount" variant="success" @click="submit">Next</b-button>
    </b-col>
    <!-- <button :disabled="!repairOfferAmount" class="btn btn-success" @click="submit">
      Next
    </button> -->
  </b-container>

</div>
</template>

<script>
export default {
  name: 'RepairEstimate',
  data() {
    return {
      repairOfferAmount: '',
    }
  },
  computed: {
    carSpec() {
      return this.$store.state.userData.carDetails.substring(0, 4)
    },
  },
  mounted() {
    if (!this.$store.state.userData.carDetails) {
      this.$router.push({
        name: 'Home',
      })
    }
  },
  methods: {
    submit() {
      this.$store.state.userData.repairOfferAmount = this.repairOfferAmount
      this.$router.push({
        name: 'PaymentCustomize',
      })
    },
  },
}
</script>

<style scoped>
.flow-title {
  padding-top: 5%;
}

.element-margin {
  margin-bottom: 13%;
  text-align: center;
}

.element-center {
  margin: 0 auto;
}

.container {
  margin-top: 6rem;
  margin-bottom: 6rem;
}

.box {
  padding: 6rem;
  border-top: 3px solid #40c991;
}

.box .separator .line {
  width: 1px;
  height: 40%;
  background-color: #a803a8;
  margin: 0 auto;
}

.box .separator .or {
  margin: 0 auto;
  width: fit-content;
  height: 20%;
  display: flex;
  align-items: center;
}

.box button {
  background-color: #40c991;
  border: none;
  border-radius: 1.2rem;
  padding: 0.5rem 4rem;
  color: #fff;
  margin: 0 auto;
  display: block;
  margin-top: 3rem;
}

select,
input {
  margin-top: 1.5rem;
  border-radius: 1rem;
}

select:focus,
input:focus {
  box-shadow: none;
}

.input-container input {
  width: 250px;
}

.input-container select {
  width: 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/repair_estimate.vue